import { BANNED_WORDS_ERROR } from '../constants'

import {
  ADD_CALL_FOR_ACTION_ASYNC,
  CHANGE_CALL_FOR_ACTION_PROPERTY,
  EDIT_CALL_FOR_ACTION_ASYNC,
  GET_CALL_FOR_ACTION_ASYNC,
  RESET_CALL_FOR_ACTION,
} from './constants'

const DEFAULT_CALL_FOR_ACTION = {
  name: '',
  title: '',
  isPublic: false,
  content: '',
}

export default function () {
  const initialState = {
    error: null,
    saveLoader: false,
    getCallForActionLoader: false,
    callForAction: DEFAULT_CALL_FOR_ACTION,
    bannedWordsError: null,
  }

  return (state = initialState, action) => {
    let newError

    switch (action.type) {
      case RESET_CALL_FOR_ACTION:
        return {
          ...initialState,
        }
      case GET_CALL_FOR_ACTION_ASYNC.INITIATE:
        return {
          ...state,
          getCallForActionLoader: true,
          error: null,
        }
      case GET_CALL_FOR_ACTION_ASYNC.SUCCESS:
        return {
          ...state,
          getCallForActionLoader: false,
          callForAction: {
            ...DEFAULT_CALL_FOR_ACTION,
            id: action.payload.callForAction.id,
            name: action.payload.callForAction.name,
            title: action.payload.callForAction.page_title,
            isPublic: action.payload.callForAction.is_public,
            content: action.payload.callForAction.content,
          },
        }
      case GET_CALL_FOR_ACTION_ASYNC.ERROR:
        return {
          ...state,
          getCallForActionLoader: false,
          error: action.error.response?.message || action.error.detail,
        }
      case ADD_CALL_FOR_ACTION_ASYNC.INITIATE:
        return {
          ...state,
          saveLoader: true,
          error: null,
          bannedWordsError: null,
        }
      case ADD_CALL_FOR_ACTION_ASYNC.SUCCESS:
        return {
          ...state,
          saveLoader: false,
          error: null,
          bannedWordsError: null,
        }
      case ADD_CALL_FOR_ACTION_ASYNC.ERROR: {
        newError = {
          error: null,
          bannedWordsError: null,
        }

        if (action.error.detail.includes(BANNED_WORDS_ERROR)) {
          newError.bannedWordsError = action.error.detail
        } else {
          newError.error = action.error.detail
        }

        return {
          ...state,
          ...newError,
          saveLoader: false,
        }
      }
      case EDIT_CALL_FOR_ACTION_ASYNC.INITIATE:
        return {
          ...state,
          saveLoader: true,
          error: null,
          bannedWordsError: null,
        }
      case EDIT_CALL_FOR_ACTION_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          saveLoader: false,
          bannedWordsError: null,
        }
      case EDIT_CALL_FOR_ACTION_ASYNC.ERROR: {
        newError = {
          error: null,
          bannedWordsError: null,
        }

        if (action.error.detail.includes(BANNED_WORDS_ERROR)) {
          newError.bannedWordsError = action.error.detail
        } else {
          newError.error = action.error.detail
        }

        return {
          ...state,
          ...newError,
          saveLoader: false,
        }
      }
      case CHANGE_CALL_FOR_ACTION_PROPERTY:
        return {
          ...state,
          callForAction: {
            ...state.callForAction,
            [action.payload.propertyName]: action.payload.value,
          },
        }
      default:
        return state
    }
  }
}
